import { useCallback, useEffect, useState } from 'react';

const RESEND_COOLDOWN_MS = 30_000;

// Seconds until a resend, counted from mount (it was just sent) and each restart(); 0 when disabled.
export const useResendCountdown = (enabled: boolean) => {
  const [endsAt, setEndsAt] = useState(() => (enabled ? Date.now() + RESEND_COOLDOWN_MS : 0));
  const [now, setNow] = useState(() => Date.now());
  const remaining = enabled ? Math.max(0, Math.ceil((endsAt - now) / 1000)) : 0;
  const running = remaining > 0;

  useEffect(() => {
    if (!running) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [running]);

  const restart = useCallback(() => {
    const start = Date.now();
    setNow(start);
    setEndsAt(start + RESEND_COOLDOWN_MS);
  }, []);

  const label = `${Math.floor(remaining / 60)}:${String(remaining % 60).padStart(2, '0')}`;
  return { remaining, label, restart };
};
